import { Bar, ComposedChart, ResponsiveContainer } from 'recharts'

import { BarInner } from '../../../components/chart/Bar'
import { CartesianGrid } from '../../../components/chart/CartesianGrid'
import { EmptyTooltip, Tooltip } from '../../../components/chart/Tooltip'
import { XAxis } from '../../../components/chart/XAxis'
import { YAxis } from '../../../components/chart/YAxis'
import { PRICE_REVISIONS_YAXIS_WIDTH, UPDOWN_REVISIONS_CHART_HEIGHT, UPDOWN_REVISIONS_TICK_COUNT } from '../constants'
import { RevisionsChartData } from '../types'

function absIntFormat(value: number): string {
  return Math.abs(value).toFixed()
}

type Props = {
  chartData: RevisionsChartData
  endingTimestamp: number
  startingTimestamp: number
}

export function UpDownRevisionsChart({ chartData, endingTimestamp, startingTimestamp }: Props) {
  return (
    <ResponsiveContainer width="100%" height={UPDOWN_REVISIONS_CHART_HEIGHT}>
      <ComposedChart
        data={chartData}
        margin={{ left: 20 + PRICE_REVISIONS_YAXIS_WIDTH, right: 24, top: 0, bottom: 0 }}
        stackOffset="sign"
        syncId="estimateRevisions"
      >
        <CartesianGrid className="first:[stroke-dasharray:0] last:[stroke-dasharray:0]" />
        <XAxis hide scale="time" type="number" dataKey="timestamp" domain={[startingTimestamp, endingTimestamp]} />
        <YAxis
          domain={['auto', 'auto']}
          orientation="right"
          tickCount={UPDOWN_REVISIONS_TICK_COUNT}
          tickFormatter={(value, idx) => (idx > 0 && idx < UPDOWN_REVISIONS_TICK_COUNT - 1 ? absIntFormat(value) : '')}
          width={PRICE_REVISIONS_YAXIS_WIDTH}
          interval={0}
        />
        <Bar
          dataKey="upRevisions"
          shape={<BarInner color="green" />}
          isAnimationActive={false}
          maxBarSize={1}
          stackId="stack"
        />
        <Bar
          dataKey="negDownRevisions"
          shape={<BarInner color="red" />}
          isAnimationActive={false}
          maxBarSize={1}
          stackId="stack"
        />
        <Tooltip content={EmptyTooltip} />
      </ComposedChart>
    </ResponsiveContainer>
  )
}
